import { render, staticRenderFns } from "./InventoryParLevel.vue?vue&type=template&id=d5bfeaa6&scoped=true&"
import script from "./InventoryParLevel.vue?vue&type=script&lang=js&"
export * from "./InventoryParLevel.vue?vue&type=script&lang=js&"
import style0 from "./InventoryParLevel.vue?vue&type=style&index=0&id=d5bfeaa6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bfeaa6",
  null
  
)

export default component.exports